import { cn } from "@/app/lib/utils/cn";

type TitleSize = "sm" | "md" | "lg";

interface GoldPinkTitleProps {
  prefix?: string;
  goldText: string;
  pinkText: string;
  noSpace?: boolean;
  size?: TitleSize;
  as?: "h2" | "h3";
  className?: string;
}

const sizeStyles: Record<TitleSize, string> = {
  sm: "text-2xl md:text-3xl xl:text-4xl",
  md: "text-3xl sm:text-4xl md:text-4xl lg:text-5xl xl:text-6xl",
  lg: "text-4xl sm:text-5xl md:text-6xl lg:text-7xl",
};

export default function GoldPinkTitle({
  prefix,
  goldText,
  pinkText,
  noSpace = false,
  size = "md",
  as: Tag = "h2",
  className,
}: GoldPinkTitleProps) {
  return (
    <Tag
      className={cn(
        "font-['Font-Bold'] text-(--gold)",
        sizeStyles[size],
        className
      )}
    >
      {prefix && <span className="text-(--text-on-purple)">{prefix} </span>}
      {goldText}
      {!noSpace && " "}
      <span className="text-(--brand)">{pinkText}</span>
    </Tag>
  );
}
